// Curated stock-photo fallbacks by cuisine so every restaurant card/detail
// shows a relevant, high-quality image even when it has no image_url.
// Base URLs are stored without query params; sizing is applied in getRestaurantImage().

const UNSPLASH = 'images.unsplash.com';

const CUISINE_IMAGES = {
  'Fine Dining': [
    'https://images.unsplash.com/photo-1616671285410-2a676a9a433d',
    'https://images.unsplash.com/photo-1689672235501-6dc1e56d454c',
    'https://images.unsplash.com/photo-1676471926534-d5c9771909fa',
  ],
  'Contemporary': [
    'https://images.unsplash.com/photo-1565895405140-6b9830a88c19',
    'https://images.unsplash.com/photo-1564759296729-771e78c26df7',
    'https://images.unsplash.com/photo-1663530761401-15eefb544889',
  ],
  'Casual Dining': [
    'https://images.unsplash.com/photo-1613274554329-70f997f5789f',
    'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4',
    'https://images.unsplash.com/photo-1583354608715-177553a4035e',
  ],
  'International': [
    'https://images.unsplash.com/photo-1467003909585-2f8a72700288',
    'https://images.unsplash.com/photo-1548940740-204726a19be3',
    'https://images.unsplash.com/photo-1631100732613-6b65da9a343d',
  ],
  'Canadian': [
    'https://images.pexels.com/photos/30301745/pexels-photo-30301745.jpeg',
    'https://images.pexels.com/photos/27703382/pexels-photo-27703382.jpeg',
  ],
  'Bakeries/Desserts': [
    'https://images.unsplash.com/photo-1483695028939-5bb13f8648b0',
    'https://images.pexels.com/photos/31228825/pexels-photo-31228825.jpeg',
    'https://images.pexels.com/photos/17593891/pexels-photo-17593891.jpeg',
  ],
  'Farm-to-Table': [
    'https://images.unsplash.com/photo-1597362925123-77861d3fbac7',
    'https://images.unsplash.com/photo-1505576633757-0ac1084af824',
  ],
  'Breweries/Distilleries': [
    'https://images.pexels.com/photos/5530251/pexels-photo-5530251.jpeg',
    'https://images.pexels.com/photos/5530263/pexels-photo-5530263.jpeg',
  ],
  'Japanese': [
    'https://images.pexels.com/photos/2098085/pexels-photo-2098085.jpeg',
    'https://images.pexels.com/photos/10562410/pexels-photo-10562410.jpeg',
  ],
  'Vegetarian/Vegan': [
    'https://images.unsplash.com/photo-1505576633757-0ac1084af824',
    'https://images.unsplash.com/photo-1597362925123-77861d3fbac7',
  ],
  'Korean': [
    'https://images.unsplash.com/photo-1590301157890-4810ed352733',
    'https://images.unsplash.com/photo-1600289031464-74d374b64991',
  ],
  'Seafood': [
    'https://images.unsplash.com/photo-1715249792880-f15e279c18dc',
    'https://images.unsplash.com/photo-1715249792962-5359b4b17f21',
  ],
  'Indigenous Cuisine': [
    'https://images.pexels.com/photos/30301745/pexels-photo-30301745.jpeg',
    'https://images.unsplash.com/photo-1597362925123-77861d3fbac7',
  ],
  'Asian Fusion': [
    'https://images.unsplash.com/photo-1585032226651-759b368d7246',
    'https://images.pexels.com/photos/2098085/pexels-photo-2098085.jpeg',
  ],
  'Wine Bar': [
    'https://images.unsplash.com/photo-1774211652790-59b4dc062fbb',
    'https://images.unsplash.com/photo-1606238023543-ba68f2cc50f8',
  ],
  'Steakhouses': [
    'https://images.unsplash.com/photo-1576511053046-7e445c5b95af',
    'https://images.unsplash.com/photo-1546964124-0cce460f38ef',
    'https://images.unsplash.com/photo-1594041680534-e8c8cdebd659',
  ],
  'Juice Bar': [
    'https://images.pexels.com/photos/4239/restaurant-drink-colorful-colourful.jpg',
    'https://images.pexels.com/photos/8181545/pexels-photo-8181545.jpeg',
  ],
  'Food Truck': [
    'https://images.unsplash.com/photo-1563002576-2e4286e7a2a7',
    'https://images.unsplash.com/photo-1766018096670-ab88f5153e2e',
  ],
};

const DEFAULT_IMAGES = [
  'https://images.unsplash.com/photo-1565895405140-6b9830a88c19',
  'https://images.unsplash.com/photo-1467003909585-2f8a72700288',
  'https://images.unsplash.com/photo-1583354608715-177553a4035e',
];

function hashStr(str = '') {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

function sized(baseUrl, w) {
  const clean = baseUrl.split('?')[0];
  if (clean.includes(UNSPLASH)) {
    return `${clean}?auto=format&fit=crop&w=${w}&q=80`;
  }
  // pexels
  return `${clean}?auto=compress&cs=tinysrgb&w=${w}`;
}

// Returns a relevant image URL for a restaurant. Uses its own image_url when
// present, otherwise a deterministic cuisine-matched stock photo.
export function getRestaurantImage(r, width = 800) {
  if (!r) return sized(DEFAULT_IMAGES[0], width);
  if (r.image_url) return r.image_url;
  const key = r.isFoodTruck ? 'Food Truck' : r.cuisine;
  const pool = CUISINE_IMAGES[key] || DEFAULT_IMAGES;
  const pick = pool[hashStr(r.id || r.name || key) % pool.length];
  return sized(pick, width);
}
